import type { ReactElement } from 'react';
import { Modal, type ModalAction } from './Modal';

export interface RestartConfirmDialogProps {
  open: boolean;
  /** Esc / backdrop / Cancel: dismiss without restarting. */
  onCancel: () => void;
  /** Restart: relaunch the application now. */
  onConfirm: () => void;
}

/**
 * Confirmation gate shown before relaunching Slate from the logo menu's
 * "Restart Slate" item. Mirrors {@link UpdateConfirmDialog}'s structure: a
 * shared {@link Modal} with a Cancel action (Esc) and a primary Restart action
 * (Enter). Performing the relaunch is the caller's responsibility; this dialog
 * only confirms intent.
 */
export function RestartConfirmDialog({
  open,
  onCancel,
  onConfirm,
}: RestartConfirmDialogProps): ReactElement | null {
  if (!open) return null;
  const actions: ModalAction[] = [
    { id: 'cancel', label: 'Cancel', onSelect: onCancel, accelerator: 'c', isCancel: true },
    {
      id: 'confirm',
      label: 'Restart',
      onSelect: onConfirm,
      accelerator: 'r',
      variant: 'primary',
      isDefault: true,
    },
  ];
  return (
    <Modal open={open} onClose={onCancel} title="Restart Slate" actions={actions}>
      <p className="mp-modal__text">Restart Slate now? Save any unsaved work first.</p>
    </Modal>
  );
}
